import makeStyles from '@mui/styles/makeStyles';
import styled, { css } from 'styled-components';
import { media } from '../../../helper/styleHelper';
import { key, palette } from 'styled-theme';
import Button from '../button';

export const useStyles = makeStyles((theme) => ({
  menuItem: {
    gap: '10px',
  },
  button: {
    position: 'absolute',
    bottom: '-50px',
    borderRadius: 'unset',
    height: '48px',
  },
  typoGraphy: {
    textTransform: 'capitalize',
  },
  dropDownMaxHeight: {
    maxHeight: '300px',
  },
}));

export const Menu = styled.div`
  position: absolute;
  width: 340px;
  right: 0px;
  overflow-y: auto;
  top: 75px;
  max-height: 400px;
  z-index: 10;
  ${(props) =>
    props.isOnlyDate
      ? css`
          padding: ${key('sizes.gutter.normal', '40px')} ${key('sizes.gutter.smaller', '20px')}
            ${key('sizes.gutter.big', '80px')};
        `
      : css`
          padding: ${key('sizes.gutter.small', '30px')} ${key('sizes.gutter.smaller', '20px')}
            ${key('sizes.gutter.big', '80px')};
        `}

  background: ${palette('background', 0)};
  border: 1px solid ${palette('background', 2)};
  box-shadow: 0px 0px 30px ${palette('shadow', 0)};
  border-radius: 10px;

  ${media.xxl`
    top: 55px;
  `};

  ${media.vxxl`
    top: 60px;
  `};
`;

export const MenuItemWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  justify-content: space-between;
`;

export const MenuGap = styled.div`
  display: grid;
  gap: 40px;
`;

export const SubmitButton = styled(Button)`
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 0px;
  height: 38px;
  border: 0px;
  &:hover {
    border-top: 1px solid ${palette('background', 2)};
  }
`;
